export default [
  {
    locationName: '云后台Y1广告位',
    locationUid: '1001'
  },
  {
    locationName: '云后台Y2广告位',
    locationUid: '1002'
  },
  {
    locationName: '云后台Y3广告位',
    locationUid: '1003'
  },
  {
    locationName: '我的店铺D1广告位',
    locationUid: '2001'
  },
  {
    locationName: '我的店铺D2广告位',
    locationUid: '2002'
  },
  {
    locationName: '官网G1广告位',
    locationUid: '3001'
  },
  {
    locationName: '官网G2广告位',
    locationUid: '3002'
  },
  {
    locationName: '官网G3广告位',
    locationUid: '3003'
  },
  {
    locationName: '官网G4广告位',
    locationUid: '3004'
  },
  {
    locationName: '官网G5广告位',
    locationUid: '3005'
  },
  {
    locationName: '官网移动端G6广告位',
    locationUid: '3006'
  },
  {
    locationName: '银豹联盟L1广告位',
    locationUid: '4001'
  },
  {
    locationName: '银豹联盟L2广告位',
    locationUid: '4002'
  },
  {
    locationName: '银豹联盟L3广告位',
    locationUid: '4003'
  },
  {
    locationName: '银豹联盟L4广告位',
    locationUid: '4004'
  },
  {
    locationName: '银豹联盟L5广告位',
    locationUid: '4005'
  },
  {
    locationName: '银豹联盟L6广告位',
    locationUid: '4006'
  },
  {
    locationName: '反馈通道S1广告位',
    locationUid: '5001'
  },
  {
    locationName: '反馈通道S2广告位',
    locationUid: '5002'
  },
  {
    locationName: '登录页G8广告位',
    locationUid: '6001'
  },
  {
    locationName: '登录页G9广告位',
    locationUid: '6002'
  },
  {
    locationName: '登录页G10广告位',
    locationUid: '6003'
  },
  {
    locationName: '登录页G11广告位',
    locationUid: '6004'
  },
  {
    locationName: '注册页G12广告位',
    locationUid: '7001'
  },
  {
    locationName: '注册页G13广告位',
    locationUid: '7002'
  },
  {
    locationName: '注册页G14广告位',
    locationUid: '7003'
  },
  {
    locationName: '注册页G15广告位',
    locationUid: '7004'
  }
]
